import Tabs from "../classes/Tabs";
import breakpoints from "../data/breakpoints";
import stateClasses from "../data/stateClasses";
import { lockScroll, unlockScroll } from "./pageScroll";

export default function init() {
	
	// get the filter tabs element
	const tabsEl = document.querySelector('.js-archive-filter-tabs');

	// if there is no tabs element, return
	if (!tabsEl) return;

	// create a new Tabs instance
	const tabs = new Tabs(tabsEl);

	// get the desktop tags container - tags filters will be appended here on desktop
	const desktopTagsContainer = tabsEl.querySelector('.js-archive-filters-desktop-tags');

	// when tabs are opened, we need need to move the content element to right place
	// on desktop - on mobile they can just go after the trigger. this is to accommodate
	// the different layouts on desktop and mobile designs
	tabsEl.addEventListener('tabOpened', (e) => {
		if (window.innerWidth > breakpoints['responsive-filters']) {
			desktopTagsContainer.append(e.detail.content);
		} else {
			e.detail.trigger.after(e.detail.content);
		}
	});

	// close all tabs when the apply button is clicked
	document.querySelectorAll('.js-archive-filter-apply-button')
		.forEach(button => {
			button.addEventListener('click', () => {
				tabs.closeAll();
				
				// hide the filters overlay too (on mobile)
				tabsEl.classList.remove(stateClasses.isActive);
				unlockScroll();
			});
		});

	// close the filters overlay when the close button is clicked (on mobile)
	document.querySelector('.js-archive-filter-close-button')
		.addEventListener('click', () => {
			tabsEl.classList.remove(stateClasses.isActive);
			unlockScroll();
		});

	// open the filters overlay when the open button is clicked (on mobile)
	document.querySelector('.js-archive-filter-open-button')
		.addEventListener('click', () => {
			tabsEl.classList.add(stateClasses.isActive);
			lockScroll();
		});
}